import React from 'react';
import ProjectEmployeeCost from './ProjectEmployeeCost';
import './ProjectEmployeeCost.scss';

const ProjectEmployeeCostMain = () => (
  <div className="project-employee-cost-wrapper">
    <div className="project-employee-cost-content">
      <ProjectEmployeeCost />
    </div>
  </div>
);

export default ProjectEmployeeCostMain;
